import LayerListItem from './LayerListItem';
import React, { useState } from 'react';
import styles from './LayerList.css';
import { v4 as uuidv4 } from 'uuid';

function LayerList({ layerListConfig, getMapRef }) {
  let llConf = [...layerListConfig];
  llConf = llConf.map((item) => {
    if (!item._id) {
      item.key = uuidv4();
      item._id = uuidv4();
    }
    return item;
  });

  const [layerList, setLayerList] = useState(llConf);

  function onChange(_id) {
    try {
      let [currentLayerListItem] = layerList.filter(
        (listItem) => listItem._id === _id
      );
      setLayerList((prevLayerList) => {
        let modifiedLayerList = prevLayerList.map((listItem) => {
          if (listItem._id === _id) {
            listItem.visible = !listItem.visible;
          }
          return listItem;
        });
        return [...modifiedLayerList];
      });
      if (currentLayerListItem) {
        const { map } = getMapRef();
        const layer = map.findLayerById(currentLayerListItem.id);
        layer.visible = currentLayerListItem.visible;
      }
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className={styles.layerList}>
      {layerListConfig.map((item) => (
        <LayerListItem onChange={onChange} {...item} />
      ))}
    </div>
  );
}

export default LayerList;
